var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "secretsManagerRoot" },
    [
      _c("div", { staticClass: "pageHeading" }, [_vm._v("Secrets Manager")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabRow", attrs: { role: "tablist" } },
        [
          _c(
            "router-link",
            {
              staticClass: "tabLink",
              class: { activeTab: !_vm.isAgentsView },
              attrs: {
                to: { name: "clientSecrets" },
                role: "tab",
                "aria-selected": String(!_vm.isAgentsView),
              },
            },
            [_vm._v("Secrets")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "tabLink",
              class: { activeTab: _vm.isAgentsView },
              attrs: {
                to: { name: "clientSecretsAgents" },
                role: "tab",
                "aria-selected": String(_vm.isAgentsView),
              },
            },
            [_vm._v("Agent Authorization")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "errorBox" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAgentsView
        ? [
            _c(
              "div",
              { staticClass: "card" },
              [
                _vm.loadingAgents
                  ? _c(
                      "div",
                      { staticClass: "loadingRow" },
                      [_c("ScaleLoader"), _vm._v(" Loading agents…")],
                      1
                    )
                  : [
                      _c("p", { staticClass: "hintText" }, [
                        _vm._v(
                          "No agent is authorized for secrets synchronization by default. Slide a control below to authorize or de-authorize an agent. De-authorizing an agent stops synchronization but does not clear the secrets the agent already has."
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.agents.length
                        ? _c("p", { staticClass: "emptyMessage" }, [
                            _vm._v("No agents are configured."),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.agents, function (agent) {
                        return _c(
                          "div",
                          { key: agent.AgentId, staticClass: "agentAuthRow" },
                          [
                            _c("div", { staticClass: "agentAuthInfo" }, [
                              _c("span", {
                                staticClass: "statusDot",
                                class: agent.IsConnected
                                  ? "dotGreen"
                                  : "dotGray",
                                attrs: {
                                  title: agent.IsConnected
                                    ? "connected"
                                    : "disconnected",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "agentAuthName" }, [
                                _vm._v(_vm._s(agent.AgentName)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "agentAuthState",
                                  class: {
                                    stateAuthorized: agent.IsAuthorized,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      agent.IsAuthorized
                                        ? "authorized"
                                        : "not authorized"
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !agent.IsConnected
                                ? _c("span", { staticClass: "mutedText" }, [
                                    _vm._v("(disconnected)"),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("slide-button", {
                              key:
                                "slideBtn_agent_" +
                                agent.AgentId +
                                "_" +
                                _vm.agentSlideBtnCounters[agent.AgentId],
                              attrs: {
                                "auto-width": false,
                                circle: true,
                                noanimate: true,
                                width: 300,
                                height: 60,
                                text: agent.IsAuthorized
                                  ? "slide to de-authorize"
                                  : "slide to authorize",
                                "success-text": agent.IsAuthorized
                                  ? "de-authorizing"
                                  : "authorizing",
                                requireReleaseToComplete: true,
                              },
                              on: {
                                completed: function ($event) {
                                  return _vm.onAgentAuthCommanded(agent)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
              ],
              2
            ),
          ]
        : [
            _c("div", { staticClass: "card toolbarCard" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filterText,
                    expression: "filterText",
                  },
                ],
                staticClass: "filterInput",
                attrs: {
                  type: "text",
                  placeholder: "Filter secrets…",
                  spellcheck: "false",
                  "aria-label": "Filter secrets",
                },
                domProps: { value: _vm.filterText },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.filterText = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "gradientButton green",
                  attrs: { type: "button" },
                  on: { click: _vm.openNewSecretDialog },
                },
                [_vm._v("Add Secret")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "gradientButton lightBlue",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.maskingEnabled = !_vm.maskingEnabled
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.maskingEnabled ? "Show Values" : "Mask Values")
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card" },
              [
                _vm.loadingSecrets
                  ? _c(
                      "div",
                      { staticClass: "loadingRow" },
                      [_c("ScaleLoader"), _vm._v(" Loading secrets…")],
                      1
                    )
                  : [
                      _vm.secrets.length
                        ? _c("div", { staticClass: "listMeta" }, [
                            _vm._v(
                              _vm._s(
                                _vm.filterText
                                  ? _vm.filteredSecrets.length +
                                      " of " +
                                      _vm.secrets.length
                                  : String(_vm.secrets.length)
                              ) +
                                " secret" +
                                _vm._s(_vm.secrets.length === 1 ? "" : "s")
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filteredSecrets.length
                        ? _c(
                            "div",
                            {
                              staticClass: "listHeader",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("div", [_vm._v("Name / Value")]),
                              _vm._v(" "),
                              _c("div", [_vm._v("Sync")]),
                              _vm._v(" "),
                              _c("div", [_vm._v("Last edit")]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.filteredSecrets, function (secret) {
                        return _c(
                          "div",
                          { key: secret.Key, staticClass: "secretRow" },
                          [
                            _c("div", { staticClass: "secretMain" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "secretNameBtn",
                                  attrs: {
                                    type: "button",
                                    title: "Edit secret '" + secret.Key + "'",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openSecretDialog(secret)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(secret.Key))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "secretValueRow" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "secretValue",
                                    class: {
                                      amasked:
                                        _vm.maskingEnabled &&
                                        !_vm.isBlankValue(secret.Value),
                                      blankValue: _vm.isBlankValue(
                                        secret.Value
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.displayValue(secret.Value))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                !_vm.isBlankValue(secret.Value)
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "copyBtn",
                                        attrs: {
                                          type: "button",
                                          title:
                                            "Copy the value of '" +
                                            secret.Key +
                                            "' to the clipboard",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyValue(secret)
                                          },
                                        },
                                      },
                                      [_vm._v("Copy")]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass: "syncBadge",
                                  class: _vm.syncBadgeClass(secret),
                                  attrs: { title: secret.SyncTooltip },
                                },
                                [_vm._v(_vm._s(secret.SyncSummary))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "lastEditCell" }, [
                              _vm._v(_vm._s(_vm.formatLastEdit(secret))),
                            ]),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      !_vm.filteredSecrets.length
                        ? _c("p", { staticClass: "emptyMessage" }, [
                            _vm._v(
                              _vm._s(
                                _vm.secrets.length
                                  ? "No secrets match the filter."
                                  : "No secrets exist yet. Add one, or authorize an agent to discover the secrets it already has."
                              )
                            ),
                          ])
                        : _vm._e(),
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card" },
              [
                _vm._m(0),
                _vm._v(" "),
                !_vm.downloadRevealed
                  ? _c("slide-button", {
                      key: "slideBtn_download_" + _vm.downloadSlideBtnCounter,
                      attrs: {
                        "auto-width": false,
                        circle: true,
                        noanimate: true,
                        width: 300,
                        height: 60,
                        text: "slide to download secrets.json",
                        "success-text": "revealed",
                        requireReleaseToComplete: true,
                      },
                      on: { completed: _vm.onDownloadRevealed },
                    })
                  : _c(
                      "a",
                      {
                        staticClass: "gradientButton green downloadLink",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.downloadSecretsJson.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v("Download secrets.json")]
                    ),
              ],
              1
            ),
          ],
      _vm._v(" "),
      _vm.editDialogVisible
        ? _c(
            "div",
            {
              staticClass: "secretDialogOverlay",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.tryCloseDialog.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "secretDialog",
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": _vm.editOriginalKey
                      ? "Edit Secret"
                      : "Add Secret",
                  },
                },
                [
                  _c("div", { staticClass: "secretDialogTitle" }, [
                    _vm._v(
                      _vm._s(_vm.editOriginalKey ? "Edit Secret" : "Add Secret")
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "fieldLabel",
                      attrs: { for: "secretNameInput" },
                    },
                    [_vm._v("Name")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editKey,
                        expression: "editKey",
                      },
                    ],
                    ref: "keyInput",
                    staticClass: "fieldInput",
                    attrs: {
                      id: "secretNameInput",
                      type: "text",
                      spellcheck: "false",
                      autocomplete: "off",
                      placeholder: "e.g. MyApiKey",
                    },
                    domProps: { value: _vm.editKey },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.editKey = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "fieldLabel",
                      attrs: { for: "secretValueInput" },
                    },
                    [_vm._v("Value")]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editValue,
                        expression: "editValue",
                      },
                    ],
                    staticClass: "fieldInput valueInput",
                    attrs: {
                      id: "secretValueInput",
                      rows: "5",
                      spellcheck: "false",
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.editValue },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.editValue = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.editSecret
                    ? _c("div", { staticClass: "metadataSection" }, [
                        _c("div", { staticClass: "metaRow" }, [
                          _c("span", { staticClass: "metaLabel" }, [
                            _vm._v("Created"),
                          ]),
                          _vm._v(
                            _vm._s(_vm.formatUtc(_vm.editSecret.CreatedUtc)) +
                              " by " +
                              _vm._s(_vm.editSecret.CreatedBy || "unknown")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "metaRow" }, [
                          _c("span", { staticClass: "metaLabel" }, [
                            _vm._v("Modified"),
                          ]),
                          _vm._v(
                            _vm._s(_vm.formatUtc(_vm.editSecret.ModifiedUtc)) +
                              " by " +
                              _vm._s(_vm.editSecret.ModifiedBy || "unknown")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "metaRow" }, [
                          _c("span", { staticClass: "metaLabel" }, [
                            _vm._v("Sync"),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "syncBadge",
                              class: _vm.syncBadgeClass(_vm.editSecret),
                              attrs: { title: _vm.editSecret.SyncTooltip },
                            },
                            [_vm._v(_vm._s(_vm.editSecret.SyncSummary))]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.editAgentSync && _vm.editAgentSync.length
                          ? _c(
                              "div",
                              { staticClass: "agentSyncList" },
                              _vm._l(_vm.editAgentSync, function (a) {
                                return _c(
                                  "div",
                                  {
                                    key: a.AgentId,
                                    staticClass: "agentSyncItem",
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "statusDot",
                                      class: a.IsSynced ? "dotGreen" : "dotRed",
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(a.AgentName) + ": "),
                                      _c(
                                        "span",
                                        {
                                          class: a.IsSynced
                                            ? "syncedText"
                                            : "notSyncedText",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              a.IsSynced
                                                ? "synced"
                                                : "not synced"
                                            )
                                          ),
                                        ]
                                      ),
                                      !a.IsConnected
                                        ? _c(
                                            "span",
                                            { staticClass: "mutedText" },
                                            [_vm._v(" (disconnected)")]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "secretDialogButtons" }, [
                    _c(
                      "button",
                      {
                        staticClass: "gradientButton green",
                        attrs: { type: "button", disabled: _vm.saving },
                        on: { click: _vm.saveSecret },
                      },
                      [_vm._v("Save")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "gradientButton lightBlue",
                        attrs: { type: "button" },
                        on: { click: _vm.tryCloseDialog },
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _vm.editOriginalKey
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "gradientButton tdsHealthBrown deleteBtn",
                            attrs: { type: "button", disabled: _vm.saving },
                            on: { click: _vm.deleteSecret },
                          },
                          [_vm._v("Delete")]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hintText downloadHint" }, [
      _vm._v("Download a copy of "),
      _c("code", { staticClass: "inline" }, [_vm._v("secrets.json")]),
      _vm._v(
        " suitable for placing on a new server that is not connected via TdsAppReleaseAgent."
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }